import React, { Component } from "react";
import { getDecodedHtml } from "utils/getDecodedHtml";

class MaterialBoxGatedDownloadModalFooter extends Component {
	render() {
		const { privacyPolicyLabel, professionalLabel, modalFooterLabel, modalFooterLink } =
			this.props.data.modal.modalFooter;
		return (
			<div className="material-email-modal-form-privacy">
				<p>
					<span dangerouslySetInnerHTML={{ __html: getDecodedHtml(privacyPolicyLabel) }}></span>
					<span dangerouslySetInnerHTML={{ __html: getDecodedHtml(professionalLabel) }}></span>
					<a
						href={modalFooterLink}
						dangerouslySetInnerHTML={{ __html: getDecodedHtml(modalFooterLabel) }}
						target="_blank"
					></a>
				</p>
			</div>
		);
	}
}
export default MaterialBoxGatedDownloadModalFooter;
